import React from "react";
import sourceActions from "../../flux/actions/SourceActions";
import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";
import * as CONSTANTS from "../../utilities/Constants";
import * as ICONCONSTANTS from "../../utilities/IconConstants";
import AbbTableComponent from "../shared/AbbTableComponent";
import { Translation } from "react-i18next";
import triggerNotifications from "../../utilities/TriggerNotifications";
import loadingActions from "../../flux/actions/LoadingActions";
import InfiniteScroll from "react-infinite-scroll-component";
import { Icon, Spinner } from "@abb/abb-common-ux-react";
import scannerActions from "../../flux/actions/ScannerAction";
import { IScannerViewData } from "../../models/scanner/ScannerViewData";
import scannerListStore from "../../flux/stores/scanner/ListStore";
import History from "../../utilities/History";

interface IViewAllState {
  list: IScannerViewData[];
}

export default class ViewAll extends React.Component<{}, IViewAllState> {
  _mount: boolean;
  private _page: number = 1;
  private _hasMore: boolean = true;
  constructor(props: {}) {
    super(props);

    this._mount = false;

    this.state = {
      list: [],
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    navigationHeaderActions
      .updateHeader({
        name: CONSTANTS.MODULE_SOURCE,
        action: CONSTANTS.VIEW_ALL,
        icon: ICONCONSTANTS.ABB_VIEW,
        goBackUrl: "",
        isGoBackWithData: false,
        goBackData: {},
        isDataChanged: false,
      })
      .then();

    this.getAll();

    scannerListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        const data = [
          ...this.state.list,
          ...(state.data.result as IScannerViewData[]),
        ];
        if (
          state.data.currentPage === state.data.totalPages ||
          state.data.totalRecords === 0
        ) {
          this._hasMore = false; // it will show message
        } else {
          this._hasMore = true; // it will show spinner
        }
        this.setState({ list: data });
      }
    });
  }

  private getAll() {
    loadingActions.setLoading(true);
    scannerActions
      .getAll(
        this._page,
        CONSTANTS.PAGE_SIZE,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then(() => loadingActions.setLoading(false))
      .catch((error) => {
        loadingActions.setLoading(false);
        triggerNotifications.errors(error.message, error.data).then();
      });
  }

  public fetchMore = () => {
    loadingActions.setLoading(true);
    this._page = this._page + 1;
    sourceActions
      .getAll(
        this._page,
        CONSTANTS.PAGE_SIZE,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then(() => {
        loadingActions.setLoading(false);
      })
      .catch(() => loadingActions.setLoading(false));
  };

  goBack = () => {
    History.push(CONSTANTS.SCANNER_INDEX_URL);
  };

  public render() {
    return (
      <Translation>
        {(t) => (
          <div id="scrollableDiv" className="page-scroll">
            <div className="app-container mt-4">
              <div className="container-box rounded-sm rounded-lg submit-header-fixed ml-1 viewall-page">
                <div>
                  <Icon
                    name="abb/caret-left"
                    sizeClass="large"
                    style={{ cursor: "pointer" }}
                    onClick={this.goBack}
                  />
                </div>
                <div className="viewall-page-title">
                  <span
                    className="title font-weight-bold mt-2 ml-1"
                    style={{ verticalAlign: "super" }}
                  >
                    {t(CONSTANTS.MODULE_SCANNER)}
                  </span>
                </div>
              </div>
              <div className="ml-1">
                <InfiniteScroll
                  dataLength={this.state.list.length} // This is important field to render the next data
                  next={this.fetchMore}
                  hasMore={this._hasMore}
                  loader={
                    <div>
                      <h6
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <Spinner color="blue" sizeClass="medium" />
                      </h6>
                      <div></div>
                    </div>
                  }
                  scrollThreshold={0.6}
                  scrollableTarget="scrollableDiv"
                >
                  <AbbTableComponent
                  authKey={CONSTANTS.AUTHKEY_SCANNER}
                    columns={[
                      {
                        dataField: "name",
                        text: t(CONSTANTS.LABLE_NAME),
                        editable: false,
                      },
                      {
                        dataField: "delimiterValue",
                        text: t(CONSTANTS.LABEL_FORMAT_TYPE),
                        editable: false,
                      },
                      {
                        dataField: "delimiter",
                        text: t(CONSTANTS.DELIMITER),
                        editable: false,
                      },
                      {
                        dataField: "scannerContent",
                        text: t(CONSTANTS.LABEL_PREVIEW),
                        editable: false,
                      },
                    ]}
                    list={this.state.list}
                    select={false}
                    isFixedColumn={false}
                    isEditable={false}
                    delete={false}
                    view={true}
                    viewAllPage={true}
                    redirectBaseUrl={CONSTANTS.MODULE_SCANNER}
                    isTitle={
                      <div className="float-left ml-1">
                        <div className="box-circle">
                          <p className="box-circle-text"> 1 </p>
                        </div>
                        <div className="ml-4">
                          <p className="sidebar-main-title font-weight-bold ml-2">
                            {t(CONSTANTS.MODULE_SCANNER)}
                          </p>
                        </div>
                      </div>
                    }
                  />
                </InfiniteScroll>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
